<template>
    <div class="mak-map" :class="{ 'view-only': viewOnly, 'mini-map': miniMap }">
        <div v-if="!miniMap" class="mak-map-header">
            <div>
                <el-button
                        v-if="viewOnly"
                        icon="el-icon-refresh"
                        @click="$emit('update', marker.position)">Güncelle</el-button>
                <el-button
                        v-else
                        type="text"
                        @click="$emit('close')"
                        icon="el-icon-back"/>
            </div>
            <div>
                <el-button
                    v-if="!viewOnly"
                    :loading="loading"
                    type="primary"
                    size="medium"
                    icon="el-icon-location"
                    @click="geolocate"
                    style="margin-right: 10px"
                />
                <a v-else :href="link" target="_blank">
                    <el-button type="primary" icon="el-icon-share" :disabled="!link">Adres Linki</el-button>
                </a>
            </div>
        </div>

        <!-- Map -->
        <googlemaps-map
                ref="map"
                :options="options"
                :center.sync="center"
                :zoom.sync="zoom">

            <!-- User Position -->
<!--            <googlemaps-user-position-->
<!--                    @update:position="setUserPosition" />-->

            <!-- Marker -->
            <googlemaps-marker
                    v-if="marker"
                    title="Paris"
                    :draggable="draggable"
                    :position.sync="marker.position"
                    @dragend="setPosition"/>

        </googlemaps-map>

        <el-row v-if="!viewOnly" class="mak-map-footer">
            <el-button
                    type="success"
                    icon="el-icon-check"
                    @click="$emit('use', marker.position)">Bu adresi kullan</el-button>
        </el-row>

    </div>
</template>

<script>

    export default {
        name: 'mak-map',
        props:  {
            viewOnly: { type: Boolean, default: false },
            miniMap: { type: Boolean, default: false },
            lat: { type: [String, Number] },
            lng: { type: [String, Number] },
        },
        data() {
            return {
                userPosition: {
                    lat: 39.925533,
                    lng: 32.866287
                },
                zoom: this.miniMap ?  17 : 12,
                center: { lat: 39.925533, lng: 32.866287 },
                loading: true,
            };
        },
        computed: {
            options() {
                return {
                    disableDefaultUI: this.miniMap || this.viewOnly,
                };
            },
            draggable() {
                return !this.viewOnly;
            },
            latitude() {
                if (!this.viewOnly) {
                    return;
                }
                return parseFloat(this.lat);
            },
            longitude() {
                if (!this.viewOnly) {
                    return;
                }
                return parseFloat(this.lng);
            },
            link() {
                if (!this.userPosition) {
                    return;
                }
                const lat = this.userPosition.lat;
                const lng = this.userPosition.lng;
                return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            },
            marker() {
                return {
                    position: this.userPosition,
                };
            },
        },
        methods: {
            centerOnUser () {
                if (this.userPosition) {
                    this.center = this.userPosition
                }
            },
            setUserPosition (position) {
                // console.warn('pos', position)
                this.userPosition = position;
                this.centerOnUser();
            },
            setPosition (position) {
                //console.warn('possss', position, position.latLng.lat(), position.latLng.lng())
                this.userPosition = {
                    lat: position.latLng.lat(),
                    lng: position.latLng.lng(),
                };
            },
            geolocate() {
                this.loading = true;
                navigator.geolocation.getCurrentPosition(position => {
                    this.userPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    setTimeout(() => {
                        this.centerOnUser();
                    }, 300);
                    this.loading = false;
                }, () => this.loading = false);
            },
        },
        mounted() {
            if (this.viewOnly) {
                setTimeout(() => {
                    this.userPosition = {
                        lat: this.latitude,
                        lng: this.longitude,
                    };
                    this.centerOnUser();
                }, 300)
            } else {
                this.geolocate();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .mak-map {
        height: 100%;
        display: flex;
        flex-direction: column;
        height: 500px;

        &.view-only {
            height: 300px;
        }

        &.mini-map {
            height: 200px;
        }

        .mak-map-header {
            display: flex;
            justify-content: space-between;
            margin: 10px 20px;
        }


        .mak-map-footer {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin: 10px 20px;

            .el-button {
                width: 100%;
            }
        }

        .vue-google-map {
            flex: 100% 1 1;
        }
    }
</style>
